import { gql } from '@generated/gql';
import {
  SmartMeterBookingInput,
  ThankYouBasketFragment,
} from '@generated/gql/graphql';

export const getSmartLinkQuery = gql(`
  query GetSmartLink($input: SmartMeterBookingInput!) {
    smartMeterBooking(input: $input) {
      link
      eligible
    }
  }
`);

export const smartMeterBookingInput = (
  basketDetails: ThankYouBasketFragment
): SmartMeterBookingInput | undefined => {
  if (!basketDetails.id) {
    return undefined;
  }

  return {
    basketId: basketDetails.id,
  };
};
